import { useEffect, useState } from "react";

/**
 * reset local state if newValue changed
 * @param newValue - initial and potentially updated value
 */
export function useFreshState(newValue) {
  const [value, setValue] = useState(newValue);

  useEffect(() => setValue(newValue), [newValue]);

  return [value, setValue];
}

export function useToggle(init) {
  const [isEnabled, setEnabled] = useState(init);
  const toggle = () => setEnabled((enabled) => !enabled);
  return [isEnabled, toggle];
}

/**
 * https://usehooks.com/
 */
export function useDebounce(value, delay) {
  // State and setters for debounced value
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(
    () => {
      // Update debounced value after delay
      const handler = setTimeout(() => {
        setDebouncedValue(value);
      }, delay);

      // Cancel the timeout if value changes (also on delay change or unmount)
      // This is how we prevent debounced value from updating if value is changed ...
      // .. within the delay period. Timeout gets cleared and restarted.
      return () => {
        clearTimeout(handler);
      };
    },
    [value, delay] // Only re-call effect if value or delay changes
  );

  return debouncedValue;
}
